import { gql } from '@apollo/client';

/**
 * ТЗ 0097 — письма из ERP: подписи и вложения. Мутации возвращают тип
 * напрямую, отказ — `GraphQLError` с `extensions { code field }`. Имена
 * операций ≠ полям бэкенда (иначе codegen схлопывает тип результата).
 */

/** Сохранить подпись; пустой `html` удаляет её (ответ — `null`). */
export const StoreMailSignatureMutation = gql`
  mutation StoreMailSignature($mailboxEmail: String, $html: String!) {
    saveMailSignature(mailboxEmail: $mailboxEmail, html: $html) {
      id
      mailboxEmail
      html
      source
      importedAt
      updatedAt
    }
  }
`;

/** «Подтянуть из Gmail» — подпись ящика из настроек Gmail (`sendAs`). */
export const PullGmailSignatureMutation = gql`
  mutation PullGmailSignature($mailboxEmail: String!) {
    importGmailSignature(mailboxEmail: $mailboxEmail) {
      id
      mailboxEmail
      html
      source
      importedAt
      updatedAt
    }
  }
`;

/** Один файл на вызов: отказ по одному файлу не роняет остальные. */
export const AddEmailAttachmentDraftMutation = gql`
  mutation AddEmailAttachmentDraft($file: Upload!) {
    uploadEmailAttachment(file: $file) {
      id
      name
      size
      mime
    }
  }
`;

/** Подписанная ссылка на вложение письма (живёт 300 с). */
export const OpenEmailAttachmentMutation = gql`
  mutation OpenEmailAttachment($messageId: ID!, $index: Int!) {
    emailAttachmentLink(messageId: $messageId, index: $index)
  }
`;
